import { render, staticRenderFns } from "./PlanItemsAddUpdate.vue?vue&type=template&id=572e6b8a&"
import script from "./PlanItemsAddUpdate.vue?vue&type=script&lang=js&"
export * from "./PlanItemsAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports